import { useEffect, useState } from 'react'
import { type NextPage } from 'next'
import curry from 'lodash.curry'

import { Heimdall } from '~/domains/platform/core/heimdall'
import { Loader } from '~/domains/platform/design-system/loader/loader'
import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'
import { type Entity, type WithDeusExMachinaProps } from '~/domains/platform/infra/deus-ex-machina/types'
import BlackBird from '~/domains/platform/lib/blackbird'
import { CleanPageContainer } from '~/ui/containers'

enum RedirectStatus {
  Loading = 'loading',
  NoRedirect = 'noRedirect'
}

const V2_HOME = '/contas-de-recebimento/v2'
const V1_HOME = '/contas-de-recebimento'

export const WithReceivableAccountsRedirectComponent = ({ Page, version, ...props }: any) => {
  const { deusExMachina } = useDeusExMachina()
  const entity = deusExMachina?.entity as Entity | undefined
  const [redirectStatus, setRedirectStatus] = useState<RedirectStatus>(RedirectStatus.Loading)

  useEffect(() => {
    if (!entity) return

    const isOneStone = entity.stoneAccount?.situation === 'one_stone'
    const hasNewReceivableAccountsFlag = Heimdall.pass(['new_receivable_accounts_web'])
    const shouldUseV2 = isOneStone && hasNewReceivableAccountsFlag

    if (version === 'v1' && shouldUseV2) {
      BlackBird.replace(V2_HOME)
    } else if (version === 'v2' && !shouldUseV2) {
      BlackBird.replace(V1_HOME)
    } else {
      setRedirectStatus(RedirectStatus.NoRedirect)
    }
  }, [entity, version])

  if (redirectStatus === RedirectStatus.Loading) {
    return (
      <CleanPageContainer>
        <Loader />
      </CleanPageContainer>
    )
  }

  return <Page {...props} />
}

export const withReceivableAccountsRedirect = curry(function (
  version: 'v1' | 'v2',
  Page: NextPage<WithDeusExMachinaProps>
) {
  return (props: any) => <WithReceivableAccountsRedirectComponent {...props} Page={Page} version={version} />
})
